"use client";

import React from "react";
import { Heart, Route, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const valuesData = [{
  title: "Sostenibilità",
  description: "Preserviamo le risorse idriche italiane attraverso tecnologie all'avanguardia che rispettano i cicli naturali della terra.",
  icon: Heart
}, {
  title: "Innovazione",
  description: "Portiamo in Italia le soluzioni Solid Dew per trasformare la gestione del suolo in un processo efficiente e redditizio.",
  icon: Route
}, {
  title: "Affidabilità",
  description: "Garantiamo risultati misurabili e supporto tecnico costante per ogni azienda agricola che sceglie il futuro verde.",
  icon: ShieldCheck
}];
export default function OurCompassionateMission() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardsRef,
    isVisible: areCardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223886" id="la-nostra-missione" className="dark bg-background py-24 md:py-32 overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row gap-12 lg:gap-24">
        
        {}
        <div className="hidden md:flex w-16 lg:w-24 shrink-0 items-center justify-center relative">
          <h2 className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-90 text-7xl lg:text-9xl font-default font-bold text-primary/10 uppercase tracking-widest whitespace-nowrap select-none">
            Missione
          </h2>
        </div>

        {}
        <div className="md:hidden">
          <h2 className="text-4xl font-default font-bold text-primary/20 uppercase tracking-widest">
            Missione
          </h2>
        </div>

        {}
        <div className="flex-1 flex flex-col gap-16 lg:gap-24">
          
          {}
          <div ref={textRef} className={`transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="text-2xl md:text-3xl lg:text-4xl leading-relaxed font-default font-medium text-foreground">
              In Solid Green Italia, la nostra missione è radicata nella convinzione che l'agricoltura italiana possa prosperare risparmiando acqua. Attraverso l'alleanza strategica con Solid Dew, forniamo tecnologie che rigenerano il suolo e ottimizzano ogni goccia, garantendo un futuro rigoglioso alle nostre radici.
            </p>
          </div>

          {}
          <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-6 transition-all duration-1000 delay-200 ease-out ${areCardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {valuesData.map((value, i) => {
            const Icon = value.icon;
            return <Card key={i} data-index={i} className="bg-card/50 border border-border/50 shadow-lg hover:shadow-xl transition-all duration-300 rounded-xl backdrop-blur-sm">
                  <CardHeader className="pb-4">
                    <div className="w-12 h-12 rounded-lg bg-secondary/20 flex items-center justify-center mb-4 text-secondary">
                      <Icon size={24} strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl font-default font-bold text-card-foreground">
                      {value.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground leading-relaxed font-default">
                      {value.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>

        </div>
      </div>
    </section>;
}